import textareaField from '@/components/services/settings/textarea/field'

export default function(h) {
  return h(
    textareaField,
    {
      props: {
        value: this.proxy,
        clearable: this.clearable,
        required: this.required,
        details: this.details
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
